import React, { useEffect } from "react";
import { ScrollTrigger } from "../animations/gsap.config";
import CareersHero from "../components/careers/CareersHero";
import CareersOverview from "../components/careers/CareersOverview";
import JobListings from "../components/careers/JobListings";
import ApplicationProcess from "../components/careers/ApplicationProcess";
import SEO from "../components/SEO";
import { useApp } from "../context/AppContext";

const Careers = () => {
  const { companyinfo } = useApp();
  /* Refresh ScrollTrigger after components mount */
  useEffect(() => {
    const timer = setTimeout(() => {
      ScrollTrigger.refresh();
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <SEO
        title="Join Our Team | Careers"
        description="Be part of a dynamic, collaborative environment driving positive change across Ethiopia. Apply for research analyst, enumerator, and development leader roles."
        keywords={[
          "Agora Consulting Jobs",
          "Development sector vacancy",
          "Research analyst career Addis Ababa",
          "MEL jobs Ethiopia",
        ]}
        url="https://agoraconsulting-et.com/careers"
        image={`${companyinfo?.logo}`}
      />
      <main className="bg-white transition-colors duration-500">
        <CareersHero />
        <CareersOverview />
        <JobListings />
        <ApplicationProcess />
      </main>
    </>
  );
};

export default Careers;
